// These values should match what is in variables.less, where applicable.

export const paddingAmount = 10
export const spacingAmount = 20
